/** Cookie key：广告来源（Proxy 门禁 + 客户端分流共用） */
export const AD_SOURCE_COOKIE_KEY = "edgen_ad_source";

/** 命中即跳过 onboarding 直落 Brief 的广告来源集合（统一大写；SAVING_ONBOARDING_SKIP 同 SAVING 承接但额外跳过 onboarding） */
export const AD_SKIP_SOURCES = new Set([
  "ALPHA_PICK",
  "PORTFOLIO_CHECK",
  "SAVING_ONBOARDING_SKIP",
]);

/** 判定某 ad_source 值是否应跳过 onboarding（纯函数，Proxy/客户端共用；统一大写比较） */
export function isAdSkipSource(value: string | null | undefined): boolean {
  if (!value) {
    return false;
  }
  return AD_SKIP_SOURCES.has(value.toUpperCase());
}

/** 从原生深链 payload 提取 ad_source（businessQuery.ad_source）。 */
export function extractAdSourceFromDeepLink(
  data: { businessQuery?: Record<string, string> } | null | undefined,
): string | null {
  const raw = data?.businessQuery?.ad_source?.trim();
  return raw ? raw : null;
}

/** 从原生深链 payload 提取 query_source（businessQuery.query_source，兴趣分类广告来源）。 */
export function extractQuerySourceFromDeepLink(
  data: { businessQuery?: Record<string, string> } | null | undefined,
): string | null {
  const raw = data?.businessQuery?.query_source?.trim();
  return raw ? raw : null;
}

/**
 * 从原生深链 payload 提取 landing_id（businessQuery.landing_id，主题榜单广告承接素材主键）。
 * 仅 trim()，大小写保真 —— 后端按主键精确匹配并自行兼容大小写，不沿用 ad_source 的大写化。
 */
export function extractLandingIdFromDeepLink(
  data: { businessQuery?: Record<string, string> } | null | undefined,
): string | null {
  const raw = data?.businessQuery?.landing_id?.trim();
  return raw ? raw : null;
}
